import React from "react";
import { MapContainer, TileLayer, Polyline, Marker, Popup, CircleMarker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const shipIcon = L.divIcon({
  className: "",
  html: '<div style="width:18px;height:18px;border-radius:50%;background:linear-gradient(135deg,#1E73BE,#16B894);border:3px solid #fff;box-shadow:0 2px 6px rgba(10,25,47,.45)"></div>',
  iconSize: [18, 18],
  iconAnchor: [9, 9],
});

export function ShipmentMap({ shipments = [] }) {
  const mapped = shipments.filter((s) => s.origin_coords && s.dest_coords);
  if (!mapped.length) return null;
  const bounds = L.latLngBounds(mapped.flatMap((s) => [s.origin_coords, s.dest_coords])).pad(0.3);

  return (
    <div className="overflow-hidden rounded-xl border border-slate-200 bg-white" data-testid="shipment-map">
      <MapContainer bounds={bounds} scrollWheelZoom={false} style={{ height: 380, width: "100%" }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {mapped.map((s) => {
          const p = Math.min(100, Math.max(0, s.progress || 0)) / 100;
          const cur = [
            s.origin_coords[0] + (s.dest_coords[0] - s.origin_coords[0]) * p,
            s.origin_coords[1] + (s.dest_coords[1] - s.origin_coords[1]) * p,
          ];
          return (
            <React.Fragment key={s.id}>
              <Polyline
                positions={[s.origin_coords, s.dest_coords]}
                pathOptions={{ color: "#1E73BE", weight: 2, dashArray: "6 8", opacity: 0.7 }}
              />
              <CircleMarker center={s.origin_coords} radius={5} pathOptions={{ color: "#0A192F", fillColor: "#0A192F", fillOpacity: 1 }} />
              <CircleMarker center={s.dest_coords} radius={5} pathOptions={{ color: "#16B894", fillColor: "#16B894", fillOpacity: 1 }} />
              <Marker position={cur} icon={shipIcon}>
                <Popup>
                  <strong>{s.title}</strong>
                  <br />
                  {s.tracking}
                  <br />
                  {s.status} · {s.progress}%
                  <br />
                  {s.origin} → {s.destination}
                </Popup>
              </Marker>
            </React.Fragment>
          );
        })}
      </MapContainer>
    </div>
  );
}
